import numbro from "numbro";
import { xlsxExport } from "../../../utils/xlsxExport";

export function addThousandSeparated(value) {
  return numbro(value).format({ thousandSeparated: true });
}

export function getExcelRowValue(tableDataUid, displayValue) {
  if (!tableDataUid) {
    return "-";
  }
  if (typeof displayValue === "number") {
    return displayValue;
  } else if (displayValue.endsWith("%")) {
    return displayValue.split("%")[0] / 100;
  } else {
    return displayValue;
  }
}

export function getFormat(valueSymbol) {
  return valueSymbol === "%"
    ? {
        xlsxFormat: "percentage",
        pattern: "#,##0%"
      }
    : {
        xlsxFormat: "number",
        pattern: "#,##0.00"
      };
}

export function exportExcelForTimeOfDay({ seriesGroup }) {
  //seriesGroup is combination of several heatmap charts,
  //therefore we need to add empty columns between each chart data in excel
  const headers = [];

  seriesGroup.forEach((group, index) => {
    if (index === 0) {
      headers.push("");
    } else {
      headers.push("", "");
    }
    headers.push(group.timeRange);
  });

  let rows = [];

  let reversedSeriesGroup = seriesGroup.map((elem) => elem.groupData.toReversed());

  reversedSeriesGroup.forEach((heatmapData) => {
    heatmapData.forEach((row, index) => {
      let { name, data } = row;
      if (!rows[index]) {
        rows[index] = [];
      }

      rows[index].push(
        name,
        getExcelRowValue(data[0].modalData.tableDataUid, data[0].displayValue),
        // for width of the column
        "       "
      );
    });
  });

  const valueSymbol = seriesGroup.flatMap((group) => group.groupData).find((elem) => elem.name)
    ?.data[0].valueSymbol;

  let format = getFormat(valueSymbol);

  xlsxExport({
    headers,
    data: rows,
    fileName: "HeatMap",
    columns: headers.map((header) => (header === "" ? {} : format))
  });
}

export const calculateTableHeight = (data) => {
  if (data <= 1) {
    return 130;
  } else if (data >= 2 && data <= 5) {
    return 200;
  }
  return data * 35;
};
